import React, { useEffect, useState, useMemo } from "react";
import "./index.scss";
import HeaderAction from "../components/HeaderAction";
import TitleLogo from "../components/TitleLogo";
import { useNavigate } from "@hooks/useNavigate";
import PATH from "../../../../config/PATH";
import {
  ID_TAB_MINI_GAME,
  useNewYear2025Theme,
  useThadingyutTheme,
  // IS_EVENT_THADINGYUT_2025_THEME,
} from "../../../../helper/const";
import { getDataSpinUserMiniGame, setDataSpinLeft, useDispatch, useSelector } from "@pages/Events/MiniGame/store";
import { curStateMiniGame } from "../../../../Redux/selector";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import ActionComponent from "../components/Action";
import MissionsList from "../components/MissionsList";
import { Button } from "antd";
import {
  getDataMissionMiniGame,
  getDataPrizeCollectionMiniGame,
  getDataSpinAwardMiniGame,
} from "../../../../Redux/futures/mini-game/action";
import PopupEarnMore from "../components/PopupFooter/PopupEarnMore";
import PopupActivityHis from "../components/PopupFooter/PopupActivityHis";
import styled from "styled-components";
import lotusIcon from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/lotus-icon.png";
import footerTree from "../../../../assets/images/Mini-Game/new-year-2025/footer-tree.png";


import logoPrizeCollection from "../../../../assets/images/Event-2026/logo-prize.png";
import iconHis from "../../../../assets/images/Event-2026/icon-btn-history.png";
import iconHomePage from "../../../../assets/images/Event-2026/icon-btn-home.png";
import PopupChangeCoin from '../components/PopupChangeCoin/PopupChangeCoin';
import { useMutation, useQueryClient } from 'react-query';
import { postMiniGameChangeAttempt } from '@api/miniGame';
import { queryKeyTurn } from 'dataLayer/user';

export default function MiniGamePrizeCollection() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isShowPopupHistory, setIsShowPopupHistory] = useState(false);
  const IS_EVENT_THADINGYUT_2025_THEME = useThadingyutTheme();
  const [turn, setTurn] = useState(1);
  const [openPopupChangeCoin, setOpenPopupChangeCoin] = useState(false);
  const [openPopupChangeCoinSuccess, setOpenPopupChangeCoinSuccess] = useState(false);
  const { dataPrizeCollectionMini = [] } = useSelector(curStateMiniGame);
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();
  const queryClient = useQueryClient();

  const changeAttemptMutation = useMutation({
    mutationFn: postMiniGameChangeAttempt,
    onSuccess: async (data) => {
      dispatch(getDataSpinAwardMiniGame());
      dispatch(getDataMissionMiniGame());
      const res = await dispatch(getDataSpinUserMiniGame());
      dispatch(
        setDataSpinLeft({
          spin_left: res?.spin_left,
          spin_left_free: res?.spin_left_free,
          spin_left_super: res?.spin_left_super,
        }),
      );
      setOpenPopupChangeCoin(false);
      setOpenPopupChangeCoinSuccess(true);
    },
    onError: (error) => {
      console.log("Error", error);
    },
  });

  const handleSubmitChangeCoin = async () => {
    changeAttemptMutation.mutate(
      {
        bid_number: turn,
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries([queryKeyTurn]);
        },
      }
    );
  };

  useEffect(() => {
    dispatch(getDataPrizeCollectionMiniGame());
  }, []);

  const handleTopage = (id) => {
    navigate(`${PATH.MINI_GAME}/${id}`);
  };

  const handleTakePrize = (data) => {
    navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.takePrize}/${data.id}`);
  };

  const dataActive = useMemo(() => {
    return dataPrizeCollectionMini.sort(
      (a, b) => Number(a.rank) - Number(b.rank)
    );
  }, [dataPrizeCollectionMini]);

  return (
    <>
      {isShowPopupHistory ? (
        <PopupActivityHis
          isShowPopupHistory={isShowPopupHistory}
          setIsShowPopupHistory={setIsShowPopupHistory}
        />
      ) : null}
      <div
        className={`container-minigame prize-collection main-prize-mini ${IS_EVENT_THADINGYUT_2025_THEME
          ? "thadingyut-theme"
          : IS_EVENT_NEW_YEAR_2025_THEME
            ? "new-year-25-theme"
            : ""
          }`}
      >
        <div className='minigame-home-header position-relative'>
          <HeaderAction />
          <TitleLogo logo={logoPrizeCollection} />
          <ActionComponent />
        </div>
        <div className='prize-container-minigame__body position-relative'>
          <div className='frame-container'>

            <div className='prize-grid'>
              {dataActive.map((item = {}, index) => (
                <div className='prize-item' key={`prize_${item.id}`} onClick={() => handleTakePrize(item)}>
                  <div
                    className={`prize-image-wrapper  scale-hover-item ${item.is_super_prize == 1 ? "super-prize" : ""
                      }`}
                  >
                    {/* {item.is_super_prize == 1 ? (
                      <img
                        src={
                          IS_EVENT_NEW_YEAR_2025_THEME
                            ? iconSuperPrizeNewYear
                            : iconSuperPrize
                        }
                        alt=''
                        className='icon-super-prize'
                      />
                    ) : null} */}
                    <img src={item.image} alt='' className='prize-image' />
                  </div>
                  <button className='prize-button'>
                    <span>
                      {item.collected < 10 ? "0" : ""}
                      {item.collected || 0} /{" "}
                      {item.piece_number < 10 ? "0" : ""}
                      {item.piece_number}
                    </span>
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className='lower-container'>
            <div className='btn-group'>
              <Button
                className='btn-item btn-item-collect btn-item-left scale-hover-item'
                onClick={() => setIsShowPopupHistory(true)}
              >
                <img src={iconHis} alt='' />
                <span style={{ marginLeft: "3px" }}>
                  {t("mini_game.prize_collection.history")}
                </span>
              </Button>

              <Button
                className='btn-item btn-item-collect btn-item-right scale-hover-item'
                onClick={() => handleTopage(ID_TAB_MINI_GAME.home)}
              >
                <span style={{ marginLeft: "3px" }}>
                  {t("mini_game.prize_collection.home_page")}
                </span>
                <img src={iconHomePage} alt='' />
              </Button>
            </div>

            <MissionsList title={t("mini_game.prize_collection.title_more_coin")}>
              <PopupEarnMore
                isMissionMini
                className='prize-collection__Earn-more-coins'
                turn={turn}
                setTurn={setTurn}
                setOpenPopupChangeCoin={setOpenPopupChangeCoin}
              />
            </MissionsList>
          </div>
          {IS_EVENT_THADINGYUT_2025_THEME && (
            <LotusIconContainer>
              <img src={lotusIcon} alt='Lotus Icon' />
            </LotusIconContainer>
          )}
          {IS_EVENT_NEW_YEAR_2025_THEME && (
            <div
              style={{
                position: "absolute",
                zIndex: 1,
                bottom: 0,
                left: 0,
                right: 0,
                width: "100%",
                pointerEvents: "none",
              }}
            >
              <img
                src={footerTree}
                alt='footer-tree'
                className='footer-tree-new-year-25-theme'
                style={{
                  width: "100%",
                }}
              />
            </div>
          )}
        </div>
      </div>

      <PopupChangeCoin
        visible={openPopupChangeCoin}
        type="change"
        bid={turn}
        setVisible={setOpenPopupChangeCoin}
        submit={handleSubmitChangeCoin}
        isLoading={changeAttemptMutation.isLoading}
      />

      <PopupChangeCoin
        visible={openPopupChangeCoinSuccess}
        setVisible={setOpenPopupChangeCoinSuccess}
        type="success"
        bid={turn}
        submit={() => {
          setOpenPopupChangeCoinSuccess(false);
          navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.home}`)
          const element = document.getElementById("mission-section");

          if (element) {
            element.scrollIntoView({
              behavior: "smooth",
            });
          }
        }}
      />

    </>
  );
}

const LotusIconContainer = styled.div`
  position: absolute;
  left: 0;
  transform: rotate(17deg) translate(-30%, -19%);
  z-index: 0;
  pointer-events: none;

  @media (max-width: 768px) {
    transform: rotate(17deg) translate(-30%, -13%);
    img {
      max-width: 85%;
    }
  }
`;
